'use strict';

/**
 *
 * @name: nnAllSeasonsExtended
 *
 */

import DirectiveTemplate from './nn-all-seasons-extended.directive.html';
import './nn-all-seasons-extended.directive.scss';

function AllSeasonsExtendedDirective(
  $rootScope,
  $timeout,
  apiSeasonsService,
  transObject,
  seasonsAnalytics,
  $q
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      scope.item = scope.content();
      scope.item.title = scope.item.title || 'ALL_SEASONS';
      scope.item.seasons = [];
      scope.analytics = seasonsAnalytics;
      scope.settings = {
        page: 1,
        limit: 12,
        order: {
          active: {
            name: 'MOST_RECENT',
            field: 'publishDate desc',
          },
          sortFields: [{
            name: 'MOST_RECENT',
            field: 'createdAt desc',
          }, {
            name: 'A-Z',
            field: 'title asc',
          }]
        },
        filter: {
          active: {
            name: 'ALL CATEGORIES',
            field: 'publishDate desc',
          },
          sortFields: angular.copy($rootScope.categoryList)
        }
      };

      scope.settings.filter.sortFields.push({
        name: 'ALL CATEGORIES',
        field: 'publishDate desc',
      });

      var goOn = true;

      /**
       *
       * @PUBLIC
       *
       */

      scope.getSeasons = function(page) {

        if (goOn) {

          goOn = false;
          page = page ? page : 1;

          var deferred = $q.defer();

          apiSeasonsService
            .getSeasons(
              page,
              scope.settings.limit,
              scope.settings.order.active.field,
              scope.settings.filter.active.id,
              $rootScope.seasons ? $rootScope.seasons.id : null
            )
            .then(function(res) {

              res.data.items.forEach(function(item) {
                transObject.translate(item);
              });

              scope.settings.totalPages = res.data.meta.totalPages;
              scope.settings.page = page;

              scope.item.seasons = (page === 1) ? res.data.items : scope.item.seasons.concat(res.data.items);

              scope.loaded = true;

              goOn = true;

              deferred.resolve(res);

            }, function() {

              return terminate();
            });

          return deferred.promise;
        }
      };

      /**
       *
       * @PRIVATE
       *
       */

      function watchSettings() {

        scope.$watch('settings', function(newVal, oldVal) {

          if (!angular.equals(newVal.order, oldVal.order) || !angular.equals(newVal.filter, oldVal.filter)) {

            scope.getSeasons();
          }
        }, true);
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      /**
       *
       * @INIT
       *
       */

      scope
        .getSeasons(scope.settings.page)
        .then(function() {

          watchSettings();
        });
    }
  };
}

export default AllSeasonsExtendedDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/seasons/nn-all-seasons-extended/nn-all-seasons-extended.directive.js